// Función para guardar el token en el localStorage
export const guardarToken = (token) => {
    localStorage.setItem('token', token)
}

// Función para obtener el token desde el localStorage
export const obtenerToken = () => {
    return localStorage.getItem('token')
}

// Función para eliminar el token del localStorage
export const eliminarToken = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
}

// Función para guardar el usuario en el localStorage
export const guardarUsuario = (usuario) => {
    localStorage.setItem('user', JSON.stringify(usuario))
}

// Función para obtener el usuario desde el localStorage
export const obtenerUsuario = () => {
    const usuario = localStorage.getItem('user')
    return usuario ? JSON.parse(usuario) : null
}


// Función para guardar el refresh token en el localStorage
export const guardarRefreshToken = (refreshToken) => {
    localStorage.setItem('refresh_token', refreshToken)
}

// Función para obtener el refresh token desde el localStorage
export const obtenerRefreshToken = () => {
    return localStorage.getItem('refresh_token')
}

// Función para eliminar el refresh token del localStorage
export const eliminarRefreshToken = () => {
    localStorage.removeItem('refresh_token')
}

